import { BrowserProvider } from 'ethers';

export function hasMetaMask() {
  return typeof window !== 'undefined' && Boolean(window.ethereum);
}

export async function connectWallet() {
  if (!hasMetaMask()) {
    throw new Error('ไม่พบ MetaMask กรุณาติดตั้ง extension ก่อน');
  }

  const provider = new BrowserProvider(window.ethereum);
  const accounts = await provider.send('eth_requestAccounts', []);
  const address = accounts[0];

  if (!address) {
    throw new Error('ไม่สามารถเชื่อม wallet ได้');
  }

  return address.toLowerCase();
}

export async function signMessage(message, address) {
  if (!hasMetaMask()) {
    throw new Error('ไม่พบ MetaMask');
  }

  const provider = new BrowserProvider(window.ethereum);
  const signer = await provider.getSigner(address);
  return signer.signMessage(message);
}
